/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Card_GuestsInputs */

const en_card_guests = /** @type {(inputs: Card_GuestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.count} guests`)
};

/**
* | output |
* | --- |
* | "Up to {count} guests" |
*
* @param {Card_GuestsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const card_guests = /** @type {((inputs: Card_GuestsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_GuestsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_card_guests(inputs)
});